/* eslint-disable import/prefer-default-export */
import { useReducer } from 'react';

// https://reactjs.org/docs/hooks-faq.html#is-there-something-like-forceupdate
export function useForceRender() {
  const [, forceUpdate] = useReducer((x) => x + 1, 0);
  return forceUpdate;
}
